export default {
  methods: {
    $can(permissionName) {
      //let Permission = this.$store.state.auth.permission;

      let Permission = [];

      if (this.$store.state.Auth.data.user.level === "STAFF 1") {
        Permission = [
          "Daftar Group",
          "Antrian Group",
          "Daftar PT",
          "Benefit",
          "Data Peserta",
          "Waiting List",
        ];
      } else {
        Permission = this.$store.state.Auth.permission;
      }
      // let Permission = ["Klaim", "QueAntrianData", "DaftarGroup"];

      // console.log("Permission", Permission);

      if (typeof Permission != "undefined") {
        return Permission.indexOf(permissionName) !== -1;
      }
    },
  },
};
